import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import SimpleBar from "simplebar-react"
import cn from "classnames"
import AppMenu from "./Menu/"
import { getMenuItems } from "./menu"
import { useDetectClickOutside } from "react-detect-click-outside"
import { withLDConsumer } from "launchdarkly-react-client-sdk"

const LeftSidebar = (props: any) => {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const ref = useDetectClickOutside({
    onTriggered: () => open && setOpen(false),
  })
  useEffect(() => {
    setOpen(false)
  }, [location.key])
  return (
    <>
      <div className={cn("leftside-menu", { open })} ref={ref}>
        <div
          onClick={() => setOpen(false)}
          className="text-2xl cursor-pointer font-bold m-6 mr-4 text-[#8391a2]"
        >
          <i className="dripicons-cross"></i>
        </div>
        <SimpleBar
          style={{ zIndex: 100, maxHeight: "100%" }}
          timeout={500}
          scrollbarMaxSize={320}
        >
          <AppMenu menuItems={getMenuItems(props.flags)} />
          <div className="h-52"></div>
        </SimpleBar>
      </div>
      <div
        aria-label="Toggle Menu"
        onClick={() => setOpen(!open)}
        className="text-2xl cursor-pointer font-bold m-6 mr-4 hover:text-gray-800 transition-all"
        role="button"
      >
        <i className="dripicons-align-left"></i>
      </div>
    </>
  )
}

export default withLDConsumer()(LeftSidebar)
